import { ReactNode } from 'react'

import { useLocation, useParams } from 'react-router'

import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Container } from '@tribeplatform/react-ui-kit/Layout'

import { useQuery } from '../../hooks/useQuery.js'
import { Layout } from './Layout.component.js'
import { SlateLayout } from './layout.enum.js'

export const PageLayout = ({
  layout,
  children,
}: {
  layout: SlateLayout
  children: ReactNode
}) => {
  const { data: network } = useNetwork()

  const { pathname } = useLocation()
  const queryParams = useQuery()
  const urlParams = useParams()
  const context = {
    path: pathname,
    urlParams,
    queryParams,
  }

  return (
    <Layout
      layout={layout}
      navigationSlates={network.navigationSlates}
      context={context}
    >
      <Container
        size="full"
        padding={{
          vertical: 'md',
          horizontal: { size: 'md', disableOnMobile: true },
        }}
      >
        {children}
      </Container>
    </Layout>
  )
}
